import { Dispatch, SetStateAction } from 'react';
import http from '../shared/HttpCommon';
import { CanceledError } from 'axios';
import { ICompetitor } from '../shared/interfaces/ICompetitor';

const getBenchmarks = async (loading: Dispatch<SetStateAction<boolean>>, signal: AbortSignal) => {
  try {
    loading(true);
    const { data } = await http.get('/benchmarking', { signal });
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const addBenchmark = async (
  platform: string,
  label: string,
  subject: ICompetitor,
  competition: ICompetitor[]
) => {
  try {
    await http.post('/benchmarking', {
      platform,
      label,
      subject,
      competition,
    });
  } catch (error) {
    console.error(error);
  }
};

const deleteBenchmarkEntry = async (benchmarkID: string, competitorID: string) => {
  try {
    await http.delete(`/benchmarking/${benchmarkID}/competitors/${competitorID}`);
  } catch (error) {
    console.error(error);
  }
};

const addBenchmarkEntry = async (
  benchmarkID: string,
  company: string,
  label: string,
  url: string
) => {
  try {
    await http.post(`/benchmarking/${benchmarkID}/competitors`, {
      company,
      label,
      url,
    });
  } catch (error) {
    console.error(error);
  }
};

const deleteBenchmark = async (id: string) => {
  try {
    await http.delete(`/benchmarking/${id}`);
  } catch (error) {
    console.error(error);
  }
};

const BenchmarkingService = {
  getBenchmarks,
  addBenchmark,
  addBenchmarkEntry,
  deleteBenchmark,
  deleteBenchmarkEntry,
};

export default BenchmarkingService;
